import { insertItemToConcreteIndex } from '../helper';
import getActualSortedOrder from './getActualSortedOrder';

export default (payloads, order, payload) => {
  const data = insertItemToConcreteIndex(payloads, order, payload);

  return getActualSortedOrder(data);
};
